module.exports = __webpack_public_path__ + "static/Research & Development-c709721a9da7fbd9d50461218e6b1fa2.png";